<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <!--HACK: v-if="dialog" is here for triggering component reload-->
    <item-add-edit-form v-if="dialog"></item-add-edit-form>
  </v-dialog>
</template>

<script>
import ItemAddEditForm from "@/components/items/ItemAddEditForm.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    ItemAddEditForm,
  },
  computed: {
    dialog: {
      get: function () {
        return this.getItemDialogStatus ? true : false;
      },
    },
    ...mapGetters(["getItemDialogStatus"]),
  },
};
</script>

<style></style>
